// extracted by mini-css-extract-plugin
module.exports = {"BubbleContentsNext":"generateDocumentsTooltips_BubbleContentsNext__2l0Wm","buttonSeparator":"generateDocumentsTooltips_buttonSeparator__1THLg"};